export enum ForgotPasswordState {
	/**
	 * Should show the email address field to see which acconut to reset.
	 */
	Initial,
	/**
	 * Should show the info text saying that an email about password reset is pending.
	 */
	EmailPending,
	/**
	 * Should show the new password form to update a password.
	 */
	Change
}
